export enum MessageType {
  Project_Created = 'Project_Created',
  Project_Updated = 'Project_Updated',
  Project_Deleted = 'Project_Deleted',
  Asset_Created = 'Asset_Created',
  Asset_Updated = 'Asset_Updated',
  Asset_Recycled = 'Asset_Recycled',
  Asset_Restore = 'Asset_Restore',
  Asset_Deleted = 'Asset_Deleted',
  Asset_Moved = 'Asset_Moved',
  File_Created = 'File_Created',
  File_Updated = 'File_Updated',
  File_Deleted = 'File_Deleted',
  Comment_Created = 'Comment_Created',
  Comment_Updated = 'Comment_Updated',
  Comment_Deleted = 'Comment_Deleted',
  Share_Created = 'Share_Created',
  Share_Updated = 'Share_Updated',
  Share_Deleted = 'Share_Deleted',
  Collect_Created = 'Collect_Created',
  Collect_Updated = 'Collect_Updated',
  Collect_Deleted = 'Collect_Deleted',
  Label_Created = 'Label_Created',
  Label_Updated = 'Label_Updated',
  Label_Deleted = 'Label_Deleted',
  Project_Joined = 'Project_Joined',
  Project_Left = 'Project_Left',
  User_Joined = 'User_Joined',
  User_Left = 'User_Left',
  User_Updated = 'User_Updated',
  Team_Updated = 'Team_Updated',
  Team_Space = 'Team_Space',
  Notification_Created = 'Notification_Created',
  Notification_Updated = 'Notification_Read',
  Notification_Deleted = 'Notification_Deleted',
}